import { createUseStorageState } from '../createUseStorageState';
var useSessionStorageState = createUseStorageState(typeof window === 'object' ? window.sessionStorage : null);
export default useSessionStorageState;